import { render, staticRenderFns } from "./EditVoucher.vue?vue&type=template&id=0879e719&"
import script from "./EditVoucher.vue?vue&type=script&lang=js&"
export * from "./EditVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports